import apiClient, { handleApiError } from '../lib/api-client';
import { API_ENDPOINTS } from '../config/api';

export interface InstagramReel {
  id: string;
  reelUrl: string;
  title?: string | null;
  thumbnailUrl?: string | null;
  displayOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export const instagramReelsService = {
  async getReels(limit = 20): Promise<InstagramReel[]> {
    try {
      const response = await apiClient.get(API_ENDPOINTS.INSTAGRAM_REELS, {
        params: { limit },
      });
      const data = response.data?.data ?? response.data;
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error('Failed to fetch Instagram reels:', error);
      return [];
    }
  },
};
